const styles = theme => ({
  container: {
    maxWidth: '1184px',
  },
  logoSize: {
    height: '20px',
    width: '20px',
  },
  full_width: {
    width: '100%',
  },
  mt10: {
    marginTop: '10px',
  },
  mb10: {
    marginBottom: '10px',
  },
  borderBottom: {
    borderBottom: '1px solid #9C9C9C',
  },
  borderTop: {
    borderTop: '1px solid #EBEEF3',
  },
  width100: {
    maxWidth: '100%',
    width: '100%',
  },

  lists: {
    marginBottom: '10px',
    [theme.breakpoints.down('sm')]: {
      paddingTop: '20px',
    },
  },
  padding10: {
    padding: '10px 0',
  },
  padding20: {
    padding: '20px 0',
  },
  lastFooter: {
    paddingTop: '24px',
    paddingBottom: '32px',
    [theme.breakpoints.down('xs')]: {
      flexDirection: 'column-reverse',
      alignItems: 'flex-start',
    },
  },
  storesIcons: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: '8px',
  },
  width25: {
    width: '25px',
    height: '25px',
  },
  socialMedia: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: '10px',
    [theme.breakpoints.down('xs')]: {
      borderBottom: '1px solid #EBEEF3',
      padding: '20px 0',
      marginBottom: '20px',
      width: '100%',
      justifyContent: 'flex-start',
    },
  },
  followUs: {
    fontWeight: '600',
    color: theme.palette.primary.white,
  },
  follow_us_on: {
    fontSize: '12px',
    lineHeight: '18px',
    fontWeight: 600,
    textAlign: 'left',
    color: '#484456',
  },
  socialMediaIcons: {
    display: 'flex',
    gap: '12px',
  },
  logoContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
    gap: '1.5rem',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'row',
      paddingBottom: '10px',
    },
  },
  ADGMLogo: {
    maxWidth: '100%',
    width: '200px',
    [theme.breakpoints.down('xs')]: {
      width: '150px',
    },
  },
  DMTDLogo: {
    maxWidth: '100%',
    width: '206px',
    [theme.breakpoints.down('xs')]: {
      width: '150px',
    },
  },

  mainFooter: {
    padding: '20px 0 10px',
    paddingTop: '32px',
    paddingBottom: '32px',
    background: theme.palette.primary.clearSky180,
    fontSize: '10px',
    color: theme.palette.primary.white,
    '& p': {
      fontSize: '10px',
    },
    '& a': {
      textDecoration: 'none',
      color: theme.palette.primary.white,
      cursor: 'pointer',
    },
  },
  DMTLogo: {
    maxWidth: '140px',
  },

  title: {
    fontSize: '12px',
    fontWeight: '600',
    marginBottom: '4px',
  },

  navList: {
    fontSize: '12px',
    padding: 0,
    marginBottom: '8px',
    '& a': {
      padding: '0',
      textDecoration: 'none',
      color: theme.palette.primary.white,
      cursor: 'pointer',
    },
    '& span': {
      fontSize: '12px',
    },
  },
  VerifiyBtnHolder: {
    textAlign: 'right',
    '& a': {
      display: 'inline-block',
      '& + a': {
        marginTop: '8px',
      },
      '& img': {
        maxWidth: '137px',
      },
    },
    [theme.breakpoints.down('sm')]: {
      padding: '10px 0',
    },
  },

  [theme.breakpoints.up('md')]: {
    mainFooter: {
      padding: '32px 0 0',
      fontSize: '12px',
      paddingBottom: '0px',
      '& p': {
        fontSize: '12px',
      },
    },
    VerifiyBtnHolder: {
      marginBottom: '10px',
      '& a': {
        '& + a': {
          marginTop: '0',
        },
        '& img': {
          maxWidth: '100%',
        },
      },
    },
  },
  [theme.breakpoints.down('sm')]: {
    navList: {
      paddingTop: '8.5px',
      paddingBottom: '0',
      display: 'flex',
      flexDirection: 'column',

      '& $navListItem': {
        width: '50%',
        '& + $navListItem': {
          paddingLeft: '8px',
          borderLeft: '1px solid #EBEEF3',
        },
      },
    },
    navListItem: {},
  },
  title_ar: {
    fontFamily: '"madani", sans-serif!important',
    lineHeight: '18px',
  },
  VerifyBtn: {
    padding: '16px 24px',
    background: theme.palette.primary.white,
    border: `1px solid ${theme.palette.primary.primary} !important`,
    color: `${theme.palette.primary.primary} !important`,
    borderRadius: '0px',
    fontWeight: '500',
    fontSize: '14px',
    fontStyle: 'Gilroy',
    width: '250px',
    height: '40px',
    textTransform: 'unset',
    '&:hover': {
      background: theme.palette.primary.white,
      border: '1px solid #342D3D !important',
    },
    '& img': {
      marginRight: '8px !important',
    },
    [theme.breakpoints.down('sm')]: {
      height: '50px',
      width: '100%',
    },
  },
  '@media (max-width: 600px)': {
    footerMargin: {
      marginBottom: '50px',
    },
  },
});

export default styles;
